<template>
    <div>
        <v-dialog v-model="dialog" width="800">
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    :disabled="loading"
                    v-bind="attrs"
                    v-on="on"
                    @click="SetValues(news)"
                    color="info"
                    >edit</v-icon
                >
            </template>
            <v-card flat class="card">
                <v-toolbar outlined flat color="primary lighten-2">
                    <v-toolbar-title>
                        تعديل
                        {{ this.$route.meta.single }}
                    </v-toolbar-title>
                    <v-spacer />
                    <v-btn @click="close()" icon>
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-form @submit.prevent="submit()" ref="form" lazy-validation>
                    <v-container>
                        <v-card outlined>
                            <v-container>
                                <v-row>
                                    <!-- <v-col cols="12" md="6">
                                        <h4 class="mb-2">
                                            العنوان
                                            <span class="required">*</span>
                                        </h4>
                                        <v-text-field
                                            v-model="item.title"
                                            placeholder="العنوان"
                                            :rules="[$global.state.required()]"
                                            required
                                            filled
                                            outlined
                                            hide-details="auto"
                                        />
                                    </v-col> -->

                                    <!-- description -->
                                    <v-col cols="12" md="12">
                                        <h4 class="mb-2">الوصف</h4>
                                        <v-textarea
                                            v-model="item.caption"
                                            required
                                            outlined
                                            filled
                                            hide-details="auto"
                                            label="لا توجد ملاحضات"
                                            color="secondary"
                                        ></v-textarea>
                                    </v-col>

                                    <!-- VideoUrl -->
                                    <v-col cols="12" md="12">
                                        <h4 class="mb-2">
                                            رابط الفيديو (اختياري)
                                        </h4>
                                        <v-text-field
                                            v-model="item.videoUrl"
                                            :rules="[$validations.urlFormat()]"
                                            outlined
                                            filled
                                            hide-details="auto"
                                            placeholder="https://example.com/video.mp4"
                                        ></v-text-field>
                                    </v-col>

                                    <!-- Video Preview -->
                                    <v-col
                                        cols="12"
                                        md="12"
                                        v-if="
                                            item.videoUrl &&
                                            isValidUrl(item.videoUrl)
                                        "
                                    >
                                        <h4 class="mb-2">معاينة الفيديو</h4>
                                        <v-card flat outlined>
                                            <!-- YouTube Video -->
                                            <div
                                                v-if="
                                                    isYouTubeUrl(item.videoUrl)
                                                "
                                            >
                                                <iframe
                                                    :src="
                                                        getYouTubeEmbedUrl(
                                                            item.videoUrl
                                                        )
                                                    "
                                                    width="100%"
                                                    height="400"
                                                    frameborder="0"
                                                    allowfullscreen
                                                ></iframe>
                                            </div>
                                            <!-- Regular Video -->
                                            <div v-else>
                                                <video
                                                    controls
                                                    style="
                                                        max-height: 400px;
                                                        width: 100%;
                                                    "
                                                >
                                                    <source
                                                        :src="item.videoUrl"
                                                        type="video/mp4"
                                                    />
                                                    <source
                                                        :src="item.videoUrl"
                                                        type="video/webm"
                                                    />
                                                    <source
                                                        :src="item.videoUrl"
                                                        type="video/ogg"
                                                    />
                                                    المتصفح لا يدعم تشغيل
                                                    الفيديو
                                                </video>
                                            </div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-col cols="12" md="12">
                            <v-row class="mt-2">
                                <v-btn
                                    type="submit"
                                    :loading="loading"
                                    x-large
                                    color="primary"
                                    class="btn"
                                    :disabled="!item.caption"
                                    >حفظ</v-btn
                                >
                                <v-btn
                                    @click="close()"
                                    x-large
                                    color="error"
                                    :disabled="loading"
                                    class="mr-2 btn"
                                    outlined
                                    >إلغاء</v-btn
                                >
                            </v-row>
                        </v-col>
                    </v-container>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import validations from "@/utils/validations";

export default {
    props: ["news"],

    data() {
        return {
            loading: false,
            dialog: false,
            item: {
                caption: "",
                videoUrl: "",
            },
            $validations: validations,
        };
    },

    mounted() {
        this.reset();
    },

    methods: {
        SetValues(item) {
            this.item.caption = item.caption ?? "";
            this.item.videoUrl = item.videoUrl ?? "";
        },
        reset() {
            this.item = {
                caption: "",
                videoUrl: "",
            };
        },
        isValidUrl(url) {
            if (!url) return false;
            const urlRegex =
                /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/?#][^\s]*)?$/i;
            return urlRegex.test(url);
        },
        isYouTubeUrl(url) {
            const youtubeRegex =
                /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)/;
            return youtubeRegex.test(url);
        },
        getYouTubeEmbedUrl(url) {
            let videoId = "";
            if (url.includes("youtube.com/watch?v=")) {
                videoId = url.split("v=")[1].split("&")[0];
            } else if (url.includes("youtu.be/")) {
                videoId = url.split("youtu.be/")[1].split("?")[0];
            } else if (url.includes("youtube.com/embed/")) {
                return url;
            }
            return `https://www.youtube.com/embed/${videoId}`;
        },

        submit() {
            this.editItem();
        },

        async editItem() {
            this.loading = true;
            let request = {
                caption: this.item.caption,
                videoUrl: this.item.videoUrl || null,
            };
            await this.$http
                .put(`${this.$route.meta.endPoint}/${this.news.id}`, request)
                .then((res) => {
                    this.close();
                    this.$store.dispatch("toastification/setToast", {
                        message: `${res.data.message}`,
                        type: "success",
                    });
                    this.$eventBus.$emit(`refresh`);
                })
                .catch((err) => {
                    console.log(err);
                    this.$store.dispatch("toastification/setToast", {
                        message: `${err.response.data.message}`,
                        type: "error",
                    });
                })
                .finally(() => (this.loading = false));
        },

        close() {
            this.reset();
            this.resetValidation();
            this.dialog = false;
        },

        resetValidation() {
            this.$refs.form.resetValidation();
        },
        getStringErrors(obj) {
            // console.log(obj,typeof(obj));
            let result = "";

            // Check if the object has a message of type string
            if (obj.message && typeof obj.message === "string") {
                result += `${obj.message}\n`;
            }

            // Check if the object has an inner object named errors
            if (obj.errors && typeof obj.errors === "object") {
                console.log("in");
                // Concatenate key-value pairs from the errors object
                for (const key in obj.errors) {
                    if (Object.prototype.hasOwnProperty.call(obj.errors, key)) {
                        // Ensure that the value is a string before appending to the result
                        if (typeof obj.errors[key] === "string") {
                            result += `${key}: ${obj.errors[key]}\n`;
                        }
                    }
                }
            }

            return result.trim(); // Trim to remove trailing newline
        },
    },
};
</script>

<style scoped>
.btn-delete-file {
    padding: 11px;
    font-weight: bold;
}
</style>
